import axios from 'axios';
import { API_BASE_URL } from '../../config/api';

export const leadApi = {
  getLead: async (tenantId: string, leadId: string) => {
    const response = await axios.get(
      `${API_BASE_URL}/tenant/${tenantId}/lead/${leadId}`,
    );
    return response.data;
  },
};
